/**
 *
 * @type {Readonly<{symptom: string, reminder: string, param: string}>}
 */
export const TaskGroups = Object.freeze({
  param: "param",
  symptom: "symptom",
  reminder: "reminder",
  pharm_recipe: "pharm_recipe",
  reminder_prevention: "reminder_prevention",
  reminder_doctor: "reminder_doctor",
  reminder_procedure: "reminder_procedure",
  reminder_analysis: "reminder_analysis",
});

/**
 * Тип группировки по датам
 * @type {Readonly<{week: string, month: string, quartets: string, days: string, years: string}>}
 */
export const TaskDatePeriods = Object.freeze({
  days: "days",
  week: "week",
  month: "month",
  quartets: "quartets",
  years: "years",
});
